import { render, staticRenderFns } from "./FileSidebarFileView.vue?vue&type=template&id=5415f091&"
import script from "./FileSidebarFileView.vue?vue&type=script&lang=js&"
export * from "./FileSidebarFileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports